export default __webpack_public_path__ + "pgnv-assets/c0d96b333b7223ab64f3cde9a590d23d.svg";